import { useAsyncTask, useNotification } from '../../../../hooks'
import { getAsyncTaskId, isAsyncTaskFinished } from '../../../../utils/async'

import { ASYNC_TASK_INTERVAL } from './useExportDirectLink.constants'

export function useExportDirectLink({
  asyncInterval = ASYNC_TASK_INTERVAL,
  onCheckTask,
  onSetFilesIds,
  onSetLoading,
  onStartExport,
}) {
  const { handleAddErrorNotification } = useNotification()

  const { handleAddAsyncTask, handleRemoveAsyncTask } = useAsyncTask()

  function handleTaskFinish(data) {
    onSetFilesIds(data.files)
    onSetLoading(false)
  }

  function checkTaskStatus(task, subject) {
    onCheckTask(task, subject)
      .then(({ data }) => {
        if (isAsyncTaskFinished(data)) {
          handleTaskFinish(data)
          handleRemoveAsyncTask(task)
        }
      })
      .catch(() => {
        handleRemoveAsyncTask(task)
        handleAddErrorNotification('Error.CommonApiRequestFailKey')
      })
  }

  function handleStartExport(subjectId, data) {
    onSetLoading(true)

    onStartExport(subjectId, data)
      .then(({ data }) => {
        const asyncTask = getAsyncTaskId(data)

        handleAddAsyncTask({
          id: asyncTask,
          interval: setInterval(() => {
            checkTaskStatus(asyncTask, subjectId)
          }, asyncInterval),
        })
      })
      .catch(() => {
        handleAddErrorNotification('Error.CommonApiRequestFailKey')
      })
  }

  return { handleStartExport }
}
